import React from "react";
import { Styled } from "./styles";
import { ModalType, useModal } from "./context";
import { CircularProgress, Typography } from "@mui/material";
import BrandsModal from "./brands-modal";
import QRCodeModal from "./qr-code-modal";
import CardsModal from "./cards-modal";
import LinksModal from "./links-modal";
import { Close } from "@dippi/icons";

const map: Record<ModalType, React.ReactNode> = {
    "qr-code": <QRCodeModal />,
    brands: <BrandsModal />,
    cards: <CardsModal />,
    links: <LinksModal />,
};

const Modal: React.FC = () => {
    const onClose = useModal(state => state.onClose);

    const loading = useModal(state => state.loading);
    const open = useModal(state => state.open);
    const modalType = useModal(state => state.modalType);
    const modalTitle = useModal(state => state.modalTitle);

    return (
        <Styled.Modal
            data-testid={`${modalType}-modal`}
            open={open}
            onClose={() => (loading ? null : onClose())}
        >
            {loading ? (
                <CircularProgress />
            ) : (
                <Styled.Content width={modalType === "qr-code" ? "auto" : "50vw"}>
                    <Styled.Header>
                        <Typography variant="h3" marginBottom={0}>
                            {modalTitle}
                        </Typography>
                        <Styled.CloseButton
                            type="button"
                            data-testid="close-modal-button"
                            onClick={onClose}
                        >
                            <Close />
                        </Styled.CloseButton>
                    </Styled.Header>
                    {map[modalType]}
                </Styled.Content>
            )}
        </Styled.Modal>
    );
};

export default Modal;
